<template>
  <div>
    <Head title="Feria de Trabajo" />
    <TheNavigationBar />
    <div
      v-if="$page.props.notification && !hideNotificationBanner"
      class="grid-container w-full p-2 bg-yellow-300 text-yellow-900"
    >
      <div class="flex w-full gap-4">
        <div class="flex grow items-center md:justify-center">
          <div
            v-if="$page.props.notification === 'create_profile_banner'"
            class="flex flex-wrap items-center text-start gap-2 sm:gap-4"
          >
            <p class="body-lg font-medium text-start">
              ¡Haz tu perfil más atractivo a reclutadores!
            </p>
            <Link
              :href="$route('profile.create')"
              class="btn-filled bg-yellow-700 text-yellow-50 !inline-block !py-1 !px-4"
              >Completa tu perfil</Link
            >
          </div>
          <p v-else class="body-md text-center">{{ $page.props.notification }}</p>
        </div>
        <Button class="px-2" @click="dismissNotification">
          <Icon name="close" class="fill-on-secondary-container" />
        </Button>
      </div>
    </div>
    <slot />
    <TheFooter />
  </div>
</template>

<script>
import { Link, Head } from '@inertiajs/inertia-vue'
import TheNavigationBar from '@/Components/TheNavigationBar'
import TheFooter from '@/Components/TheFooter'
import Icon from '@/Components/Icon'

export default {
  name: 'Layout',
  components: {
    Link,
    Head,
    TheNavigationBar,
    TheFooter,
    Icon,
  },
  computed: {
    hideNotificationBanner() {
      const rules = [
        this.$page.props.notification === 'create_profile_banner' &&
          this.$page.url.startsWith('/perfil/crear'),
      ]

      return rules.every(rule => rule === true)
    },
    showOnThisPageAllowed() {
      const isNotCurrentUrl = currentValue => !this.$page.url.startsWith(currentValue)
      return ['/ofertas', '/empresa'].every(isNotCurrentUrl)
    },
    user() {
      return this.$page.props.auth.user
    },
    message() {
      if (this.$page.props.flash.message) {
        this.$swal.fire({
          toast: true,
          timer: 10000,
          position: 'bottom',
          showConfirmButton: false,
          timerProgressBar: true,
          title: this.$page.props.flash.message,
          customClass: {
            icon: '!bg-transparent',
            title:
              '!text-on-surface-variant !font-sans !font-medium !text-base !tracking-wide !text-center',
          },
        })
        return this.$page.props.flash.message
      }
    },
  },
  methods: {
    dismissNotification() {
      this.$inertia.get(this.$route('notification.dismiss'))
    },
  },
}
</script>
